/* eslint-disable max-len */
import { createFeature, createReducer, on } from '@ngrx/store';
import * as luxon from 'luxon';

import * as actions from './stack-location-get.actions';
import { StackLocationGetI } from 'src/app/api/stack-location-get/stack-location-get.result.int';

export interface State {
    error: string;
    loaded: boolean;
    loading: boolean;
    data: StackLocationGetI;
    receivedTime: string;
}

export const initialState: State = {
    error: null,
    loaded: false,
    loading: false,
    data: null,
    receivedTime: null,
};

export default createFeature({
  name: 'stackLocationGet',
  reducer: createReducer(
    initialState,
    on(actions.error, (state: State, { messageText }): State => ({
        ...state,
        error: messageText,
        loaded: false,
        loading: false
    })),
    on(actions.reset, (state: State): State => ({
        ...state,
        data: null,
        error: null,
        loaded: false,
        loading: false
    })),
    on(actions.received, (state: State, { result }): State => ({
        ...state,
        data: result,
        error: null,
        loaded: true,
        loading: false,
        receivedTime: luxon.DateTime.now().toISO(),
    })),
    on(actions.load, (state: State, { }): State => ({
        ...state,
        loaded: false,
        loading: true
    }))
  )}
);